export default "__VITE_ASSET__BVORh1pU__"